export class CaseDetailLabels {
  cdlId: string;
  cdlCaseTypeId: string;
  cdlLabel1: string;
  cdlLabel2: string;
  cdlLabel3: string;
  cdlLabel4: string;
}